import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  CreateButton,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  ShowButton,
  SimpleList,
  TextField,
  TopToolbar,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { DoctoralSchoolCampaignStatusChoices, DoctoralSchoolCampaignStatusColorMap } from "utils/choices";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import StatusChip from "../Partials/StatusChip";
import DoctoralDateField from "../Partials/DoctoralDateField";

const ListDoctoralSchoolCampaigns = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return <TopToolbar>{hasCreate && <CreateButton />}</TopToolbar>;
  };

  return (
    <List
      title="Докторантско училище"
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateDoctoralSchoolCampaigns)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
                            <MobileListRow
                fields={[
                  { label: "Начало", value: <DoctoralDateField source="dateFrom" /> },
                  { label: "Край", value: <DoctoralDateField source="dateTo" /> },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: DoctoralSchoolCampaignStatusChoices.find(c => c.id === record.status)?.name,
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateDoctoralSchoolCampaigns}>
                <EditButton label="" />
              </SecuredComponent>
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <TextField source="nameBg" label="Име на български език" sortable={false} />
                    <DoctoralDateField source="dateFrom" label="Начало" sortable={false} />
          <DoctoralDateField source="dateTo" label="Край" sortable={false} />
          <FunctionField
            label="Статус"
            render={record => (
              <StatusChip
                status={record.status}
                choices={DoctoralSchoolCampaignStatusChoices}
                colorMap={DoctoralSchoolCampaignStatusColorMap}
              />
            )}
          />
          <SecuredComponent permission={permissions.canUpdateDoctoralSchoolCampaigns}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListDoctoralSchoolCampaigns;
